import { createContext, useContext } from 'react'
import type { UseSectionCompositionResult } from './hooks/useSectionComposition'
import type { UseSectionFilteractionResult } from './hooks/useSectionFilteraction'
import type { UseSectionGroupActionsResult } from './hooks/useSectionGroupActions'
import type { UseSectionNavigationResult } from './hooks/useSectionNavigation'
import type {
  SectionContextProviderProps,
  SectionContextValue
} from './SectionContext.types'

const SectionContext = createContext<SectionContextValue | null>(null)

export { SectionContext }

export const useSectionContext = (): SectionContextValue => {
  const value = useContext(SectionContext)
  if (!value) {
    throw new Error(
      'useSectionContext must be used within SectionContext.Provider'
    )
  }
  return value
}

export const useSectionNavigation = (): UseSectionNavigationResult => {
  const { navigation } = useSectionContext()

  return navigation
}

export const useSectionFilteraction = (): UseSectionFilteractionResult => {
  const { filteraction } = useSectionContext()

  return filteraction
}

export const useSectionComposition = (): UseSectionCompositionResult => {
  const { composition } = useSectionContext()

  return composition
}

export const useSectionGroupActions = (): UseSectionGroupActionsResult => {
  const { groupActions } = useSectionContext()

  return groupActions
}

export const SectionContextProvider = ({
  value,
  children
}: SectionContextProviderProps) => {
  return (
    <SectionContext.Provider value={value}>{children}</SectionContext.Provider>
  )
}
